import { useEffect, useState } from 'react';

type PagerHookReturn = {
    firstPage: number;
    lastPage: number;
    setLastPage: (page: number) => void;
    currentPage: number;
    setCurrentPage: (page: number) => void;
    startIndex: number;
    endIndex: number;
    numDataRows: number;
};

export const useSetUpPager = (dataLength: number, buttonIncrement: number): PagerHookReturn => {
    // Everything you need to use the vake Pager from ui-kit
    const [lastPage, setLastPage] = useState<number>(1);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [startIndex, setStartIndex] = useState<number>(0);
    const [endIndex, setEndIndex] = useState<number>(-1);
    const [numDataRows, setNumDataRows] = useState<number>(-1);
    const firstPage = 1;
    useEffect(() => {
        setNumDataRows(dataLength);
        setLastPage(Math.ceil(dataLength / buttonIncrement));
        setStartIndex(0);
        setEndIndex(dataLength >= buttonIncrement ? buttonIncrement : dataLength);
    }, [dataLength, buttonIncrement]);
    useEffect(() => {
        setStartIndex((currentPage - 1) * buttonIncrement);
        setEndIndex(currentPage * buttonIncrement);
    }, [currentPage, buttonIncrement]);
    return { firstPage, lastPage, setLastPage, currentPage, setCurrentPage, startIndex, endIndex, numDataRows };
};
